import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IDailyDealsAsset, IDailyDealsSale } from 'models/daily-deals/i-daily-deals';
import { IState } from 'models/reducers/i-state.interface';

import { refreshDailyDealsUpdateTokenAction } from 'actions/daily-deals.actions';

import CompleteCheckoutOfferModal from 'components/modal/completeCheckoutModal/CompleteCheckoutOfferModal';

import { useDailyDealsEvents } from 'hooks/events/useDailyDealsEvents';

import DailyDealsSale from '../dailyDealsSale/DailyDealsSale';
import { IDailyDealsProps } from '../dailyDealsSection/DailyDealsSection';

interface IDailyDealsTradePreviewDetails {
  tradeDetails: IDailyDealsSale;
  assetDetails: IDailyDealsAsset;
}

const DailyDealsSales = ({ deal }: IDailyDealsProps) => {
  const dispatch = useDispatch();
  const { dealsAssets } = useSelector((state: IState) => state.dailyDeals);
  const dealAsset = dealsAssets.find((asset) => asset.id === deal?.asset.id);

  const [isBuyModalVisible, setIsBuyModalVisible] = useState<boolean>(false);
  const [itemPreviewDetails, setItemPreviewDetails] = useState<IDailyDealsTradePreviewDetails | undefined>(undefined);

  const dailyDealsBuyEvents = useDailyDealsEvents();

  const onOpenModal = (itemPreviewDetails: IDailyDealsTradePreviewDetails) => {
    setIsBuyModalVisible(true);
    setItemPreviewDetails(itemPreviewDetails);
  };

  const onCloseModal = () => {
    setIsBuyModalVisible(true);
    setItemPreviewDetails(undefined);
  };

  const onPurchaseFinished = () => {
    dispatch(refreshDailyDealsUpdateTokenAction());
  };

  const onPurchase = (activeSales: IDailyDealsSale[]) => {
    const randomOffer = activeSales[Math.floor(Math.random() * activeSales.length)];

    if (!!dealAsset && !!randomOffer) {
      const itemPreviewDetails: IDailyDealsTradePreviewDetails = {
        tradeDetails: randomOffer,
        assetDetails: dealAsset,
      };

      onOpenModal(itemPreviewDetails);
    }
  };

  return (
    <>
      <div className="tw-mb-5 tw-mt-2 tw-w-full lg:tw-ml-7.5 lg:tw-overflow-x-auto lg:tw-px-0">
        <p className="tw-text-2xl">{dealAsset?.name}</p>
        <p className="tw-text-sm">{dealAsset?.address}</p>
        <div className="xl:tw-min-w-[396px]">
          {deal?.items.map((item, idx) => (
            <DailyDealsSale key={idx} {...item} onPurchase={onPurchase} />
          ))}
        </div>
      </div>
      {isBuyModalVisible && itemPreviewDetails && (
        <CompleteCheckoutOfferModal
          tradePreviewDetails={itemPreviewDetails}
          onClose={onCloseModal}
          onFinished={onPurchaseFinished}
          events={dailyDealsBuyEvents}
        />
      )}
    </>
  );
};

export default DailyDealsSales;
